import React, { useEffect, useState } from 'react';
import './DBOSHomepage.css';
import SiteHeader from './SiteHeader';

const DBOSHomepage = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('dbos-cookie-consent');
    if (!consent) {
      setShowCookieBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('dbos-cookie-consent', 'accepted');
    setShowCookieBanner(false);
  };

  const [expandedTile, setExpandedTile] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [formStatus, setFormStatus] = useState(null);

  const handleFormSubmit = async (e, tile) => {
    e.preventDefault();
    setFormStatus('sending');
    try {
      const res = await fetch('https://europe-west1-dbos-core-prod.cloudfunctions.net/sendRequestForm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, solution: tile.name, country: 'IE' }),
      });
      if (res.ok) {
        setFormStatus('success');
      } else {
        setFormStatus('error');
      }
    } catch (err) {
      setFormStatus('error');
    }
  };

  const tiles = [
    { id: 'smartdata', name: 'SmartData', badge: 'live', badgeClass: 'tile-badge-live',
      short: 'All your files, organised and searchable.',
      blurb: 'Every document, photo, and invoice your business generates, automatically organised and instantly searchable - no folders to maintain, no filing system to remember.',
      bullets: ['AI-powered organisation from day one', 'Search by content, not just filename', '10GB storage, 500 AI labels lifetime'],
      cta: 'trial', link: '/smartdata' },
    { id: 'smartshop', name: 'SmartShop', badge: 'live', badgeClass: 'tile-badge-live',
      short: 'Sell online, checkout included.',
      blurb: 'A full online shop for your business - product catalogue, cart, and secure checkout, live today.',
      bullets: ['Product catalogue and cart, ready out of the box', 'Secure checkout via Stripe', 'Your brand, not a third-party badge'],
      cta: 'trial', link: '/smartshop' },
    { id: 'smartweb', name: 'SmartWeb', badge: 'guided setup', badgeClass: 'tile-badge-guided',
      short: 'Your digital storefront, always current.',
      blurb: 'A professional web presence that stays current without you having to touch it - built and maintained as part of your onboarding.',
      bullets: ['Professional design, built for you', 'Always up to date', 'Guided setup with our team'],
      cta: 'request', link: '/smartweb' },
    { id: 'smartmail', name: 'SmartMail', badge: 'guided setup', badgeClass: 'tile-badge-guided',
      short: 'Newsletters and customer replies, sorted.',
      blurb: 'Dedicated, isolated email infrastructure for your business - newsletters, customer replies, and campaigns, all under your own brand.',
      bullets: ['Dedicated sending infrastructure', 'GDPR-compliant consent tracking', 'Guided setup with our team'],
      cta: 'request', link: '/smartmail' },
    { id: 'smartfinance', name: 'SmartFinance', badge: 'guided setup', badgeClass: 'tile-badge-guided',
      short: 'Invoices and bookkeeping, sorted.',
      blurb: 'Cash-basis accounting built for how small businesses actually work - invoices, entries, and audit-ready records, without double-entry complexity.',
      bullets: ['Cash-basis ledger, IE/DE/US rules', 'Live profit & loss view', 'Guided setup with our team'],
      cta: 'request', link: '/smartfinance' },
    { id: 'smarttraffic', name: 'SmartTraffic', badge: 'coaching - €89/mth', badgeClass: 'tile-badge-coaching',
      short: '3 sessions, your digital footprint fixed.',
      blurb: 'A guided, 3-month coaching programme to fix your digital footprint - three sessions with a real person, not a self-serve tool.',
      bullets: ['3 guided sessions over 3 months', 'Real one-on-one coaching', '€89/month, cancel anytime'],
      cta: 'request', link: '/smarttraffic' },
  ];





  return (
    <div className="dbos-homepage">
      <SiteHeader active="" />
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title shimmering gold-gradient">Work Smarter Together. Scale Without Chaos.</h1>
            <p className="hero-subtitle">
              Technology should empower your people, not overwhelm them. DBOS streamlines your core operations into one central platform - taking the heavy lifting out of routine processes so your team can focus on what actually grows the business.
            </p>
            <div className="hero-ctas">
              <a href="https://login.dbos.world/register" target="_blank" rel="noopener noreferrer" className="btn-primary shimmering-btn">
                Start Free Trial
                <span className="btn-arrow">→</span>
              </a>
            </div>
            <p className="hero-small-print">Secured with 2FA. Your data stays in the EU.</p>
          </div>
        </div>
      </section>

      <section className="content-section solutions-section">
        <div className="container">
          <h2 className="section-title">One System. Six Ways It Helps.</h2>
          {!expandedTile ? (
          <div className="solutions-grid">
            {tiles.map((tile) => (
              <button key={tile.id} className="solution-tile" onClick={() => { setExpandedTile(tile.id); setShowForm(false); setFormStatus(null); setFormData({ name: '', email: '', phone: '' }); }}>
                <span className={`tile-badge ${tile.badgeClass}`}>{tile.badge}</span>
                <h3>{tile.name}</h3>
                <p>{tile.short}</p>
              </button>
            ))}
          </div>
          ) : (
            (() => {
              const tile = tiles.find((t) => t.id === expandedTile);
              return (
                <div className="tile-detail">
                  <button className="tile-back" onClick={() => setExpandedTile(null)}>
                    <span className="tile-back-arrow">←</span> Back to overview
                  </button>
                  <div className="tile-detail-card">
                    <div className="tile-detail-header">
                      <h3>{tile.name}</h3>
                      <span className={`tile-badge ${tile.badgeClass}`}>{tile.badge}</span>
                    </div>
                    {!showForm ? (
                      <>
                    <p className="tile-detail-blurb">{tile.blurb}</p>
                    <ul className="tile-detail-bullets">
                      {tile.bullets.map((b, i) => (
                        <li key={i}>{b}</li>
                      ))}
                    </ul>
                    <div className="tile-detail-actions">
                      <a href={tile.link} className="btn-secondary">See full details</a>
                      {tile.cta === 'trial' ? (
                        <a href="https://login.dbos.world/register" target="_blank" rel="noopener noreferrer" className="btn-primary">Start Free Trial</a>
                      ) : (
                          <button className="btn-primary" onClick={() => { setShowForm(true); setFormStatus(null); setFormData({ name: '', email: '', phone: '' }); }}>Request Onboarding</button>
                      )}
                    </div>
                      </>
                    ) : formStatus === 'success' ? (
                      <p className="tile-form-success">Thanks - we'll be in touch shortly.</p>
                    ) : (
                      <form className="tile-form" onSubmit={(e) => handleFormSubmit(e, tile)}>
                        <input
                          type="text"
                          placeholder="Your Name"
                          required
                          value={formData.name}
                          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          className="tile-form-input"
                        />
                        <input
                          type="email"
                          placeholder="your@email.com"
                          required
                          value={formData.email}
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          className="tile-form-input"
                        />
                        <input
                          type="tel"
                          pattern="[0-9+\-\s()]*"
                          inputMode="tel"
                          title="Numbers, spaces, +, -, and () only"
                          placeholder="Phone (optional)"
                          value={formData.phone}
                          onChange={(e) => setFormData({ ...formData, phone: e.target.value.replace(/[^0-9+\-\s()]/g, '') })}
                          className="tile-form-input"
                        />
                        <button type="submit" className="btn-primary" disabled={formStatus === 'sending'}>
                          {formStatus === 'sending' ? 'Sending...' : 'Send Request'}
                        </button>
                        {formStatus === 'error' && (
                          <p className="tile-form-error">Something went wrong - please try again or email hello@dbos.world.</p>
                        )}
                      </form>
                    )}
                  </div>
                  <button className="tile-back" onClick={() => setExpandedTile(null)}>
                    <span className="tile-back-arrow">←</span> Back to overview
                  </button>
                </div>
              );
            })()
          )}
        </div>
      </section>

      <section className="content-section trust-section">
        <div className="container">
          <h2 className="section-title">Trusted in Practice</h2>
          <div className="trust-card">
            <img src="/assets/img/glen-salmon-essaness.jpg" alt="Glen Salmon, Essaness Music" className="trust-photo" />
            <div className="trust-content">
              <p className="trust-quote">"We had 5,000 product photos with names like IMG_0482.jpg. SmartData labeled them all in 2 days. Game changer."</p>
              <p className="trust-author">Glen Salmon - <a href="https://essanessmusic.ie" target="_blank" rel="noopener noreferrer" className="trust-inline-link">Essaness Music</a>, Kilkenny</p>
              <a href="https://www.kilkennypeople.ie/news/business/long-established-kilkenny-business-hits-high-noteswith-new-digital-platform-8663863" target="_blank" rel="noopener noreferrer" className="trust-press">
                <img src="/assets/img/kilkenny-people.jpg" alt="Kilkenny People" className="trust-press-logo" />
                As featured in the Kilkenny People
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="hero-story">
            <p className="story-question">What if you took a four-week holiday - and didn't worry about your business once?</p>
            <p className="story-question">What if a supplier called at 3 AM, and the system handled it without waking you?</p>
            <p className="story-question">What if an auditor asked for three years of records, and you sent them in three clicks?</p>
            <p className="story-answer"><strong>That's what DBOS stands for:</strong> Building an asset that runs on logical processes you define once, then automate where possible - in one holistic, integrated solution. Start small with one module. Scale as your ROI grows. Own a business, not a job.</p>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container footer-compact">
          <div className="footer-row-1">
            <span className="footer-hours-inline"><span className="hours-label">Opening Hours (IST):</span> Mon-Thu 9:00-18:00 | Fri 9:00-12:00 | Sat-Sun Closed</span>
          </div>
          <div className="footer-row-2">
            <span className="copyright">© 2026 DBOS. Ireland (CRO Registered). All rights reserved.</span>
            <span className="footer-divider">|</span>
            <a href="/legal/terms">Terms</a>
            <a href="/legal/privacy">Privacy</a>
            <a href="/legal/cookies">Cookies</a>
            <a href="/legal/dpa">DPA</a>
            <span className="footer-divider">|</span>
            <a href="mailto:hello@dbos.world">hello@dbos.world</a>
          </div>
        </div>
      </footer>
      
      {showCookieBanner && (
        <div className="cookie-banner">
          <div className="cookie-content">
            <p>We use essential cookies to ensure our website functions properly. By continuing, you accept our use of necessary cookies. <a href="/legal/cookies">Learn more</a></p>
            <button onClick={acceptCookies} className="cookie-accept">Accept</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DBOSHomepage;